import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, Router } from '@angular/router';
import { ConfigService } from '@klickdata/core/config';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AuthService } from '../token/auth.service';
import { Utils } from '@klickdata/core/util';
import { CustomerLanding } from '@klickdata/core/customer';

@Injectable({
    providedIn: 'root',
})
export class GuestStartGuard implements CanActivate, CanLoad {
    constructor(protected authService: AuthService, protected router: Router, protected configService: ConfigService) {}

    public canActivate(): Observable<boolean> {
        return this.authService.check().pipe(
            switchMap((authenticated) => {
                if (authenticated) {
                    this.redirect();
                    return of(false);
                }
                return this.handleSubdomainCheck();
            })
        );
    }

    private handleSubdomainCheck(): Observable<boolean> {
        return this.authService.checkSubdomain().pipe(
            switchMap((fromKlickdata) =>
                this.authService.getCustomerLanding().pipe(map((data) => ({ landing: data, fromKlickdata })))
            ),
            map(({ landing, fromKlickdata }) => this.evaluateLanding(fromKlickdata, landing))
        );
    }

    private evaluateLanding(fromKlickdata: boolean, landing: CustomerLanding): boolean {
        if (!fromKlickdata) {
            if (landing.guest_mode) {
                this.authService.openGuestModeLanding(this.router);
            } else {
                this.authService.openLoginPage(false, this.router);
            }
            return false;
        }
        return true; // Allow navigation.
    }

    public canLoad(route: Route): Observable<boolean> {
        return this.canActivate();
    }

    protected redirect(): void {
        this.router.navigate(['home']);
    }
}
